@if (showModal) {
  <form [formGroup]="wrongAddressForm" (ngSubmit)="reportAddress()">
    <app-modal
        [attr.data-test]="'modal-reportWrongAddress'"
        [open]="showModal"
        [id]="'wrongAddressModal'"
        title="{{ 'checkout-delivery-details.report-wrong-address' | translate }}"
        (crossClick)="resetForm()"
        (outsideClick)="resetForm()">
      <ng-container ngProjectAs="[slot][body]">
        @if (loading) {
          <div class="loader__overlay">
            <div class="loader__content">
              <div class="loading-animation"></div>
            </div>
          </div>
        }
        <div class="row">
          <app-select-box
              class="col-12"
              [form]="wrongAddressForm"
              [modelValue]="wrongAddressForm.value.deliveryAddress"
              [options]="addresses"
              [inputName]="'deliveryAddress'"
              label="{{ (cpqLabelName ? cpqLabelName : 'checkout-delivery-details.delivery-address') | translate }}"
              [isRequired]="true"
              [readOnly]="addresses?.length === 1"
              [loading]="addressesLoading"
              (selected)="selectWrongAddress($event)">
          </app-select-box>
        </div>
        <div class="row">
          <app-textarea
              class="col-12"
              [form]="wrongAddressForm"
              [modelValue]="wrongAddressForm.value.comment"
              [rows]="3"
              [cssStyles]="{wrapper: 'text-area-comment'}"
              [inputName]="'comment'"
              [maxLength]="maxLengthComment"
              label="{{ 'checkout-delivery-details.comment' | translate }}"
              [isRequired]="true"
              trim
              trimWhitespaces
              (areaFilled)="setCommentWrongAddress($event.value)">
          </app-textarea>
          <div class="form-alerts">
            @if (wrongAddressForm.value.comment) {
              <small class="textfield__hint">
                {{ wrongAddressForm.value.comment.length }}/{{ maxLengthComment }}
              </small>
            }
          </div>
        </div>
        @if (!cpqOnly) {
          <div>
            @if (roleSpecificMessage) {
              <p>
                {{ 'checkout-delivery-details.wrong-address-notification' | translate }}
              </p>
            } @else if ((isApproverBuyerWorkflowEnabled$ | async) && !hasApproverAccess()) {
              <p>
                {{ 'checkout-delivery-details.wrong-address-notification-buyer' | translate }}
              </p>
            } @else {
              <p>
                {{ 'checkout-delivery-details.wrong-address-notification-approver' | translate }}
              </p>
            }
          </div>
        }
      </ng-container>
      <ng-container ngProjectAs="[slot][footer]">
        <button
            type="reset"
            class="button button"
            data-dismiss="modal-dialog"
            [attr.data-test]="'button-cancelReportWrongAddress'"
            (click)="resetForm()">
          {{ 'checkout-delivery-details.cancel' | translate }}
        </button>
        <button
            type="submit"
            class="button button--primary"
            data-dismiss="modal-dialog"
            [disabled]="!formIsValid()"
            [attr.data-test]="'button-reportWrongAddress'"
            (click)="showLoader()">
          {{ 'checkout-delivery-details.send-wrong-address' | translate }}
        </button>
      </ng-container>
    </app-modal>
  </form>
}
